import { render, staticRenderFns } from "./PanelWithAgendaEditor.vue?vue&type=template&id=0d5c825e&lang=pug&"
import script from "./PanelWithAgendaEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithAgendaEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithAgendaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports